import React, { useCallback } from "react";
import { ErrorBoundary } from "./ErrorBoundary";
import { useLogger } from "./useLogger";
/**
 * Declarative error boundary bound to the LoggerProvider's `Logger`: captures render errors with the
 * given per-capture tags and renders `fallback` afterwards.
 */
const ErrorHandler = ({ children, fallback, layer, section }) => {
    const logger = useLogger();
    const captureException = useCallback((error, hint) => logger.captureException(error, hint, { layer, section }), [logger, layer, section]);
    return (React.createElement(ErrorBoundary, { captureException: captureException, fallback: fallback }, children));
};
export { ErrorHandler };
